
import React, { useEffect, useRef, useState } from "react";
import { gsap, Linear } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import $ from "jquery";
import "./service_1.css";

function useTitle(title) {
  useEffect(() => {
    const prevTitle = document.title
    document.title = title
    return () => {
      document.title = prevTitle
    }
  })
}
export default function Service_1() {

  
  useTitle("PPS - Service_1")
  useEffect(() => {
    
    
    gsap
    .timeline()
    .to('#service_1 p', { rotationX: 360, rotationY: 360, rotationZ: 360, repeat: -1 , duration: 10, ease: Linear.easeNone })

  });

  return (
    <div>
      <div id="service_1" className="content">
        <p>Service 1</p>
        </div>
    </div>
  );
}
